<template>
  <div class="auth-page">
    <TheBreadcrumbs :links="breadCrumbsLinks"/>
    <div class="auth-page__content container">
      <div class="auth-page__inner container-inner">

        <div class="auth-page__main" v-if="windowSizeMixin.width > 767">
          <div style="max-width: 50rem; margin: 0 auto"
               class="auth-page__col">
            <AuthLogin :previousPage="previousPage"/>
          </div>
        </div>

        <transition-group v-else
                          tag="div"
                          :name="showRegMob ? 'slide-right' : 'slide-left'"
                          class="auth-page__main">
          <div class="auth-page__col"
               :key="2">
            <AuthLogin :previousPage="previousPage"/>
          </div>
        </transition-group>
      </div>
    </div>
    <!--    <AuthSocials class="auth-page__socials" v-if="windowSizeMixin.width < 768"/>-->
  </div>
</template>

<script>
  import TheBreadcrumbs from "@/components/Breadcrumbs";
  import formMixins from '@/mixins/formMixins'
  import AuthLogin from '@/components/AuthLogin'
  import windowSizeMixin from '@/mixins/windowSizeMixin'

  export default {
    mixins: [formMixins, windowSizeMixin],
    components: {
      TheBreadcrumbs,
      AuthLogin,
    },
    data() {
      return {
        messageUser: null,
        showRegMob: true,
        previousPage: null
      }
    },
    computed: {
      breadCrumbsLinks() {
        return [{
          name: this.$tAuth('Authorization / registration')
        }]
      }
    },
    methods: {},
    created() {

    },
    mounted() {

    },
    beforeRouteEnter(to, from, next) {
      if (from.name && to.name !== from.name) {
        return next(vm => {
          vm.previousPage = from
        })
      }

      next()
    }
  }
</script>

<style lang="less">


</style>
